import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Heart = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="m11.53 4.63.43.47.47-.46a5.68 5.68 0 014.9-1.56A5.58 5.58 0 0122 8.58v.23c0 1.62-.67 3.17-1.86 4.28l-7.06 6.59a1.59 1.59 0 01-2.16 0l-7.06-6.6A5.85 5.85 0 012 8.82v-.23a5.58 5.58 0 019.53-3.95Z"
    />
  </svg>
));
